import { useContext, useEffect } from 'react';
import { Activities, attraqtTracker } from '../../../analytics/attraqt/attraqtTracker';
import { ListerContext } from '../listerContext';

const { isSearchResultsPage } = window.globalLister;

function useAttraqtTrackerViewEvent(): void {
  const [
    {
      rid,
      currentQuery: { freeTextSearch }
    }
  ] = useContext(ListerContext);

  useEffect(() => {
    const viewEvent = {
      action: Activities.VIEW,
      sourceId: rid,
      target: {
        page: window.location.pathname
      }
    };

    if (isSearchResultsPage) {
      viewEvent.target['search-terms'] = freeTextSearch;
      attraqtTracker(viewEvent);
    } else {
      attraqtTracker(viewEvent);
    }
  }, [rid]);
}

export default useAttraqtTrackerViewEvent;
